module.exports = __webpack_public_path__ + "img/Retail16.255811ea.png";